import moment from 'moment';
import { range as lodashRange } from 'lodash';
import { globalConfig } from './global-config';
/**
 * 选择器结果变更处理，需要 this.format 存在
 * @param  value 选中值
 */

function onChange(value) {
  var format = this.format;
  var _a = this.props,
      name = _a.name,
      onChange = _a.onChange,
      range = _a.range;
  /**
   * 当前选中的时间
   */

  var date;

  if (value) {
    var _b = range || {
      start: undefined,
      end: undefined
    },
        start = _b.start,
        end = _b.end;

    if (start) {
      start = moment(start, format);

      if (start > value) {
        value = start;
      }
    }

    if (end) {
      end = moment(end, format);

      if (end < value) {
        value = end;
      }
    }

    date = value.format(format);
  } else {
    date = value;
  }

  if (onChange) {
    onChange(date, name);
  }
}
/**
 * 区间选择器结果变更处理，需要 this.format 存在
 * @param value 选中区间
 */


function onRangeChange(value) {
  var format = this.format;
  var _a = this.props,
      name = _a.name,
      onChange = _a.onChange,
      range = _a.range;
  /**
   * 当前变更前的时间
   */

  var date;

  if (value && value.length) {
    var start = value[0],
        end = value[1];

    var _b = range || {
      start: undefined,
      end: undefined
    },
        startLimit = _b.start,
        endLimit = _b.end;

    if (startLimit) {
      startLimit = moment(startLimit, format);

      if (startLimit > start) {
        start = startLimit;
      }

      if (startLimit > end) {
        end = startLimit;
      }
    }

    if (endLimit) {
      endLimit = moment(endLimit, format);

      if (endLimit < start) {
        start = endLimit;
      }

      if (endLimit < end) {
        end = endLimit;
      }
    }

    date = {
      start: start.format(format),
      end: end.format(format)
    };
  } else {
    date = null;
  }

  if (onChange) {
    onChange(date, name);
  }
}
/**
 * 检查日期是否可选，需要 this.format 存在
 * @param date 要渲染的日期
 */


function disabledDate(date) {
  if (!date) {
    return false;
  }

  var format = this.format;
  var range = this.props.range;

  if (range) {
    var start = range.start,
        end = range.end;
    date = moment(date).startOf('date');
    return (start ? date < moment(start, format).startOf('date') : false) || (end ? date > moment(end, format).startOf('date') : false);
  } else {
    return false;
  }
}
/**
 * 提供不可选时间检查，需要 this.format 存在
 * @param date 要渲染的日期
 */


function disabledTime(date) {
  var format = this.format;
  var dateFormat = globalConfig.get('format.date') || '';
  if (!date || !this.props.range) return;
  var _a = this.props.range,
      start = _a.start,
      end = _a.end;
  var startHour = 0;
  var startMinute = 0;
  var startSecond = 0;
  var endHour = 23;
  var endMinute = 59;
  var endSecond = 59;

  if (start) {
    start = moment(start, format);

    if (date.format(dateFormat) === start.format(dateFormat)) {
      startHour = start.hour();
      startMinute = start.minute();
      startSecond = start.second();
    }
  }

  if (end) {
    end = moment(end, format);

    if (date.format(dateFormat) === end.format(dateFormat)) {
      endHour = end.hour();
      endMinute = end.minute();
      endSecond = end.second();
    }
  }

  return {
    disabledHours: function disabledHours() {
      return lodashRange(0, startHour).concat(lodashRange(endHour + 1, 24));
    },
    disabledMinutes: function disabledMinutes(selectedHour) {
      return lodashRange(0, selectedHour === startHour ? startMinute : 0).concat(lodashRange(selectedHour === endHour ? endMinute + 1 : 60, 60));
    },
    disabledSeconds: function disabledSeconds(selectedHour, selectedMinute) {
      return lodashRange(0, selectedHour === startHour && selectedMinute === startMinute ? startSecond : 0).concat(lodashRange(selectedHour === endHour && selectedMinute === endMinute ? endSecond + 1 : 60, 60));
    }
  };
}
/**
 * 日期或时间选择器公用方法，提供选择器类组件处理标准行为
 */


export var pickerHelper = {
  onChange: onChange,
  onRangeChange: onRangeChange,
  disabledDate: disabledDate,
  disabledTime: disabledTime
};